import { ifItemExists } from '../utils/ifItemExists';

const dropdownTrigger = document.querySelector('#category-select');
const catsList = document.querySelector('.category-list');
let isOpen = false;

const categoryDropdown = () =>
  dropdownTrigger.addEventListener('touchstart', toggleDropdown);

const toggleDropdown = () => {
  dropdownTrigger.querySelector('svg').classList.toggle('rotate-180');
  catsList.classList.toggle('is-visible');
  isOpen = !isOpen;
};

ifItemExists(dropdownTrigger, () => categoryDropdown());

window.addEventListener('click', (e) => {
  if (!catsList?.contains(e.target) && e.target !== dropdownTrigger) {
    isOpen ? toggleDropdown() : null;
  }
});
